export default "__VITE_ASSET__0Luck5tb__"